module.exports = __webpack_public_path__ + "media/images/icon-storage-on@3x-0992e571f241f060d3b2bc647cc0d87f.png";